import BaseApi from '@core/api/model';

export class ExchangeApi extends BaseApi {
    static resource = 'exchanges';
}

export default ExchangeApi;
